import Tablesort from 'tablesort';

// @see 'tablesort/src/sorts/tablesort.number.js';
(function () {
  var cleanNumber = function (i) {
      return i.replace(/[^\-?0-9.]/g, '');
    },
    compareNumber = function (a, b) {
      a = parseFloat(a);
      b = parseFloat(b);

      a = isNaN(a) ? 0 : a;
      b = isNaN(b) ? 0 : b;

      return a - b;
    };

  Tablesort.extend(
    'number',
    function (item) {
      return (
        item.match(/^[-+]?(\d)*-?([,]){0,1}-?(\d)+([E,e][+][\d]+)?%?$/)
      );
    },
    function (a, b) {
      a = cleanNumber(a);
      b = cleanNumber(b);

      return compareNumber(b, a);
    }
  );
})();

export function convertBbpressForumsListToTable(
  containerSelector = '#bbpress-forums'
) {
  const wrapper = document.querySelector(containerSelector);
  if (!wrapper) return null;

  if (wrapper.querySelector('table.bbp-forums-table'))
    return wrapper.querySelector('table.bbp-forums-table');

  const list = wrapper.querySelector('ul.bbp-forums');
  if (!list) return null;

  const table = document.createElement('table');
  table.className = 'bbp-forums-table sortable';
  table.id = 'bbpress-forums-table';
  table.setAttribute('border', '1');

  const headerItems = list.querySelectorAll('.bbp-header .forum-titles > li');
  if (headerItems.length) {
    const thead = document.createElement('thead');
    const tr = document.createElement('tr');
    headerItems.forEach((li) => {
      const th = document.createElement('th');
      th.scope = 'col';
      th.textContent = li.textContent.trim();
      if (['topics', 'posts'].includes(li.textContent.trim().toLowerCase())) {
        th.dataset.sortMethod = 'number';
      }
      if (li.textContent.trim().toLowerCase() === 'last post') {
        th.dataset.sortDefault = true;
      }
      tr.appendChild(th);
    });
    thead.appendChild(tr);
    table.appendChild(thead);
  }

  const tbody = document.createElement('tbody');
  const rowLists = list.querySelectorAll('.bbp-body > ul[id^="bbp-forum-"]');

  rowLists.forEach((rowUl) => {
    const tr = document.createElement('tr');
    if (rowUl.id) tr.id = rowUl.id;
    if (rowUl.className) tr.className = rowUl.className;
    tr.classList.remove('odd', 'even');

    const selectors = [
      '.bbp-forum-info',
      '.bbp-forum-topic-count',
      '.bbp-forum-reply-count',
      '.bbp-forum-freshness',
    ];

    selectors.forEach((sel) => {
      const td = document.createElement('td');
      const li = rowUl.querySelector(sel);
      if (li) {
        td.innerHTML = li.innerHTML;
        if (li.querySelector('[data-datetime]')) {
          td.setAttribute(
            'data-sort',
            li.querySelector('[data-datetime]').getAttribute('data-datetime')
          );
        }
      } else {
        td.textContent = '';
      }
      tr.appendChild(td);
    });

    tbody.appendChild(tr);
  });

  table.appendChild(tbody);

  list.replaceWith(table);

  new Tablesort(table, {
    descending: true,
  });

  return table;
}
